/* ===========================================================
   HARVEYS WOODWORX
   BESPOKE PRICING DATABASE
=========================================================== */


const bespokePricing = {


labourRate:200,


markup:0.45,


minimumLabourHours:2,



timberCosts:{


Saligna:9000,

Mopani:16000,

Hardekool:20000,

Meranti:11000,

Kiaat:25000


},



finishCosts:{


"Mineral Oil":150,

"Board Butter":200,

"Hardwax Oil":400,

"Varnish":300


}


};